export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const CUR_HEADERMENUITEM = 'CUR_HEADERMENUITEM'


// WEBPACK FOOTER //
// ./src/store/type.js